import { gbConstants } from "../_constants";
import { authHeader } from "../_helpers";

export const notiService = {
    readNoti
};

const notiReadURL = `${gbConstants.HOST_SERVICE}/v1.1/notification/read`;

function readNoti(noti) {
	var ids =""
	noti.map(function(data,idx){
		if (idx==0){
			ids+=data.id
		}else {
			ids+=","+data.id
		}
	})
	NotiRead(ids)}
function NotiRead(ids){
    const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
        	UserId: 0,
        	Ids : ids,
        }),
    };
    return fetch(notiReadURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
           
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }
            return data;
        });
}



// WEBPACK FOOTER //
// ./src/_services/notification.service.js